<app-automations-table
  [type]="type"
  [viewType]="viewType"
  tableType="DocumentAutomations"
  (add)="onAdd()"
  (edit)="onEdit($event)"
  (duplicate)="onDuplicate($event)"
  [showActions]="showActions"
>
  <p emptyContent class="mt-4">
    <a href="javascript:;" (click)="onAdd()" *ngIf="!(1 | isReadonlyRole)" i18n>Click here</a>&nbsp;<ng-container i18n
      >to create your first automation and simplify your processes today.</ng-container
    >
  </p>
</app-automations-table>
